import React from 'react';
import './App.css';
import { HashRouter as BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import OverOnsPage from './pages/OverOnsPage';
import HistoriePage from './pages/HistoriePage';
import CertificeringPage from './pages/CertificeringPage';
import DienstenPage from './pages/DienstenPage';
import VacaturesPage from './pages/VacaturesPage';
import VacatureDetailPage from './pages/VacatureDetailPage';
import VoorKandidatenPage from './pages/VoorKandidatenPage';
import VoorOpdrachtgeversPage from './pages/VoorOpdrachtgeversPage';
import OpdrachtOpgevenPage from './pages/OpdrachtOpgevenPage';
import OnzeOplossingenPage from './pages/OnzeOplossingenPage';
import DuurzameDetacheringPage from './pages/DuurzameDetacheringPage';
import { DDOpdrachtgeverPage, DDKandidatenPage } from './pages/DuurzameDetacheringSubPages';
import { DuurzaamheidsprofessionalsPage, DuurzaamheidsprofessionalsOpdrachtenPage } from './pages/DuurzaamheidsprofessionalsPages';
import { FinanceprofessionalsPage } from './pages/FinanceprofessionalsPage';
import { HRprofessionalsPage } from './pages/HRprofessionalsPage';
import DocumentatiePage from './pages/DocumentatiePage';
import RecruitmentfraudePage from './pages/RecruitmentfraudePage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import NotFoundPage from './pages/NotFoundPage';

// GEO/AI optimized pages
import GidsInterimFinancePage from './pages/GidsInterimFinancePage';
import VeelgesteldeVragenPage from './pages/VeelgesteldeVragenPage';
import SpecialismePage from './pages/SpecialismePage';
import { LocatiePage, LocatiesOverviewPage } from './pages/LocatiePage';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />

            {/* Over ons */}
            <Route path="/over-ons" element={<OverOnsPage />} />
            <Route path="/historie" element={<HistoriePage />} />
            <Route path="/certificering" element={<CertificeringPage />} />

            {/* Diensten */}
            <Route path="/diensten" element={<DienstenPage />} />

            {/* Kandidaten */}
            <Route path="/voor-kandidaten" element={<VoorKandidatenPage />} />

            {/* Opdrachtgevers */}
            <Route path="/voor-opdrachtgevers" element={<VoorOpdrachtgeversPage />} />
            <Route path="/opdracht-opgeven" element={<OpdrachtOpgevenPage />} />
            <Route path="/onze-oplossingen" element={<OnzeOplossingenPage />} />

            {/* Duurzame Detachering */}
            <Route path="/duurzame-detachering" element={<DuurzameDetacheringPage />} />
            <Route path="/duurzame-detachering/opdrachtgever" element={<DDOpdrachtgeverPage />} />
            <Route path="/duurzame-detachering/kandidaten" element={<DDKandidatenPage />} />

            {/* Discipline pages */}
            <Route path="/duurzaamheidsprofessionals" element={<DuurzaamheidsprofessionalsPage />} />
            <Route path="/duurzaamheidsprofessionals-opdrachten" element={<DuurzaamheidsprofessionalsOpdrachtenPage />} />
            <Route path="/financeprofessionals" element={<FinanceprofessionalsPage />} />
            <Route path="/hrprofessionals" element={<HRprofessionalsPage />} />

            {/* Vacatures */}
            <Route path="/vacatures" element={<VacaturesPage />} />
            <Route path="/vacatures/:id" element={<VacatureDetailPage />} />

            {/* Informatie */}
            <Route path="/documentatie" element={<DocumentatiePage />} />
            <Route path="/recruitmentfraude" element={<RecruitmentfraudePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            {/* GEO/AI optimized pages */}
            <Route path="/gids-interim-finance" element={<GidsInterimFinancePage />} />
            <Route path="/veelgestelde-vragen" element={<VeelgesteldeVragenPage />} />
            <Route path="/specialisme/:slug" element={<SpecialismePage />} />
            <Route path="/locaties" element={<LocatiesOverviewPage />} />
            <Route path="/locaties/:slug" element={<LocatiePage />} />

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
